module.exports = __webpack_public_path__ + "img/albania-logo-icon.8b98cba1.png";